import _ from 'lodash'
import { Map } from 'immutable'

import config from '../../../../../../config'

import { TOGGLE_BLOCK_TABLE_HISTORY_BUTTON } from './constants'

export default (state = Map(), action = {}) => {
    switch (action.type) {
        case TOGGLE_BLOCK_TABLE_HISTORY_BUTTON: {
            const tableId = _.get(action, 'data.tableId', null)
            const buttonId = _.get(action, 'data.buttonId', null)
            if (!tableId || !buttonId) return state

            const actualOpen = state.getIn([tableId, buttonId, 'open'], config.components.blockTable.historyOpen)

            return state.setIn([tableId, buttonId, 'open'], !actualOpen)
        }
        default:
            return state
    }
}
